// extracted by mini-css-extract-plugin
export default {"navbar":"buildsHeader_navbar__Li4mL","searchButtonHidden":"buildsHeader_searchButtonHidden__1n3WQ","spacer":"buildsHeader_spacer__iGYau","brandLink":"buildsHeader_brandLink__42K06"};